import React from 'react'
import PropTypes from 'prop-types'
import { PrimaryText, Title } from '../../shared/StyledComponents'

const SpaBuildDetailComponent = ({ items }) => {
    return (
        <div className='spabuydetail mt-4'>

            <div className='flex gap-2'>
                <img src="/assets/img/icons/massage2-icon.svg" alt="Icono masaje 3" width={'32px'} height={'32px'} />
                <Title>Detalle de compra</Title>
            </div>


            <div className='mt-4'>
                <PrimaryText size={16}>
                    Oxigenoporación:
                </PrimaryText>

                <div className='flex justify-between items-center mt-4'>
                    <div className='flex gap-2 items-center'>
                        <img src="/assets/img/icons/calendar-icon.svg" alt="Icono masaje 3" width={'32px'} height={'32px'} />
                        <span>1 - Dic - 2021</span></div>
                    <div className='flex gap-2 items-center'>
                        <img src="/assets/img/icons/person-icon.svg" alt="Icono masaje 3" width={'24px'} height={'24px'} />
                        <span>x2</span>
                    </div>
                    <strong><PrimaryText size={18}>
                        USD $240
                    </PrimaryText></strong>
                </div>

                <div className="line mt-4" style={{ background: '#C4C4C4' }}></div>
            </div>
        </div>
    )
}

SpaBuildDetailComponent.propTypes = {
    items: PropTypes.func
}

export default SpaBuildDetailComponent